export enum apiUrlNotification {
    ADMIN_NOTIFICATIONS = '/v1/admin-notifications/',
}
